"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.paddingInlineStartEnd = exports.paddingBlockStartEnd = void 0;

var _styledComponents = require("styled-components");

var _edenStyleConstants = require('../../../../eden-style-constants');

const paddingBlockStartEnd = _edenStyleConstants.spacing4;
exports.paddingBlockStartEnd = paddingBlockStartEnd;
const paddingInlineStartEnd = _edenStyleConstants.spacing16;
exports.paddingInlineStartEnd = paddingInlineStartEnd;
const shared = (0, _styledComponents.css)(["text-transform:none;overflow:visible;display:inline-flex;align-items:center;justify-content:center;margin:0;border:0;border-radius:0.125rem;cursor:pointer;font-weight:", ";", ";vertical-align:top;text-decoration:none;padding:", " ", ";font-family:", ";line-height:", ";color:", ";", ";&:hover{color:", ";text-decoration:none;}&[disabled],&[disabled]:hover{", ";cursor:not-allowed;border:none;}"], _edenStyleConstants.fontWeightNormal, ({
  fullWidth
}) => fullWidth ? "width: 100%" : "max-width: 18rem", paddingBlockStartEnd, paddingInlineStartEnd, _edenStyleConstants.sans, _edenStyleConstants.lineHeightTight, _edenStyleConstants.text120, ({
  small
}) => small ? `font-size: ${_edenStyleConstants.fontSize14}; 
        min-height: 2rem;
        ` : `font-size: ${_edenStyleConstants.fontSize16};
        min-height: 2.5rem;
        `, _edenStyleConstants.text120, ({
  inverted
}) => inverted ? `background: ${_edenStyleConstants.grey40};
          color: ${_edenStyleConstants.text120};` : `background: ${_edenStyleConstants.grey3};
          color: ${_edenStyleConstants.grey20};`);
var _default = shared;
exports.default = _default;